import { ComponentProps } from 'react';
import { PersonHelpers } from '@frontend/api-person';
import { useTranslation } from '@frontend/i18n';
import { formatPhoneNumber } from '@frontend/phone-numbers';
import { GetWeavePopNotificationByType } from '@frontend/types';
import { Chip, Text } from '@frontend/design-system';
import { BaseNotificationComponentProps, BaseNotificationInner, BaseNotificationOuter } from './base';

type Props = BaseNotificationComponentProps<GetWeavePopNotificationByType<'fax-tag'>>;

export const FaxTagNotificationComponent = ({ isHistorical, emit, notification, ...rest }: Props) => {
  const { t } = useTranslation();
  const actions: ComponentProps<typeof BaseNotificationInner>['actions'] = [
    {
      Icon: undefined,
      label: t('View'),
      action: () => {
        emit({ action: 'view', payload: undefined }, notification);
      },
    },
  ];

  return (
    <BaseNotificationOuter
      actions={actions}
      notification={notification}
      emit={emit}
      isHistorical={isHistorical}
      {...rest}
    >
      <BaseNotificationInner
        onClose={() => emit({ action: 'ignore', payload: undefined }, notification)}
        actions={actions}
        title={t('Tag Applied to Fax')}
        body={
          <>
            <Chip.Tag color={notification.payload.tagColor}>{notification.payload.tagName}</Chip.Tag>
            <Text weight='bold'>
              {PersonHelpers.getFullName({
                FirstName: notification.payload.contact?.firstName,
                LastName: notification.payload.contact?.secondName,
              }) || formatPhoneNumber(notification.payload.contact?.faxNumber)}
            </Text>
          </>
        }
        location={notification.location}
        timestamp={notification.timestamp}
        id={notification.id}
        notificationType={notification.type}
        {...rest}
      />
    </BaseNotificationOuter>
  );
};
